import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { getTranscriptEmptyStateInfo } from './TranscriptionStatusEmptyStateData';
import { jsx as _jsx } from "react/jsx-runtime";
export const TranscriptionStatusEmptyState = props => {
  const {
    transcriptionStatus,
    isTranscriptionAdmin,
    isUsageLimitReached
  } = props;
  const {
    title,
    illustration,
    description
  } = getTranscriptEmptyStateInfo(transcriptionStatus, isTranscriptionAdmin, isUsageLimitReached);
  return /*#__PURE__*/_jsx(ErrorMessage, {
    illustration: illustration,
    title: title,
    children: /*#__PURE__*/_jsx("p", {
      children: description
    })
  });
};